import { Schema } from 'effect';
import {
  CloudStorageProviderSchema,
  IntegrationConnectionOutcomeSchema,
} from '@listening/api-contract/integration-providers';
import { optionalCatching } from './search-params';

export const cloudStorageImportSearch = Schema.toStandardSchemaV1(
  Schema.Struct({
    integration: optionalCatching(CloudStorageProviderSchema),
    connection: optionalCatching(IntegrationConnectionOutcomeSchema),
  }),
);
